import React, { useContext, useEffect, useRef, useState } from 'react';
import { ProgressBar, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FiAlertTriangle } from 'react-icons/fi';
import { webSocketUrl } from '@/app/common/api/config';
import { useParams } from 'react-router-dom';
import { Centrifuge } from 'centrifuge';
import { useGenerateTokenMutation } from '@/app/common/api/socketApi';
import keywordsApi from '@/app/KeywordTracker/api/keywordsApi';
import useDomain from '@/hooks/useDomain';

const UpdateProgressBar = ({ isOnUpdate, setIsOnUpdate }) => {
  const dispatch = useDispatch();
  const { domain_slug } = useDomain();
  const [token, setToken] = useState(null);
  const retryToOpen = useRef(0);
  const [progressData, setProgressData] = useState();
  const [generateToken] = useGenerateTokenMutation();

  useEffect(() => {
    const fetchToken = async () => {
      await generateToken({
        id: domain_slug,
        channels: [`personal:#${domain_slug}`]
      })
        .unwrap()
        .then(response => {
          setToken(response.data);
        })
        .catch(err => {
          console.error('Error fetching data:', err);
        });
    };

    fetchToken();
  }, []);

  const [connected, setConnected] = useState(false);
  useEffect(() => {
    if (token) {
      const centrifugo = new Centrifuge(webSocketUrl, {
        getToken: async ctx => {
          return token;
        }
      });

      centrifugo.on('connecting', () => {
        // console.log('Connecting to socket');
      });

      centrifugo.on('connected', () => {
        setConnected(true);
        // console.log('Connected to socket');
      });

      centrifugo.on('disconnected', () => {
        // console.log('Disconnected from socket');
        setConnected(false);
        setIsOnUpdate(false);
        setTimeout(() => {
          dispatch(keywordsApi.util.invalidateTags(['tracker_info']));
        }, 3000);
      });

      centrifugo.on('publication', message => {
        console.log(
          'Socket Data:',
          message?.data?.total,
          message?.data?.finished
        );
        if (message) {
          if (message?.data?.total === message?.data?.finished) {
            centrifugo.disconnect();
            dispatch(keywordsApi.util.invalidateTags(['keywordsPage']));
          }
          setProgressData({
            total: message?.data?.total,
            finished: message?.data?.finished
          });
        }
      });

      centrifugo.connect();
    }
  }, [token]);
  if (!connected) return null;
  return progressData ? (
    <div className="d-flex mb-3 justify-content-between rounded bg-body-tertiary shadow-sm p-2 gap-1 align-items-center">
      <div className="w-100">
        <div className="mb-1" style={{ fontSize: '14px' }}>
          {progressData.finished} کلمه کلیدی از {progressData.total} به‌روز شد.
          <span className="float-end">
            {progressData.total === 0
              ? 0
              : Math.floor((progressData.finished * 99) / progressData.total)}
            %
          </span>
        </div>
        <ProgressBar
          now={progressData.finished}
          max={progressData.total}
          style={{ height: 5 }}
          className="rounded-pill align-middle"
          variant="success"
        />
      </div>
    </div>
  ) : (
    ''
  );
};
export default UpdateProgressBar;
